import Vue from 'vue';
import Router from 'vue-router';
import _ from 'lodash';
import nav from '@/data/nav';
import store from '@/store';

const view = path => () => import(`@/views${path}.vue`);
Vue.use(Router);

const subsFromNav = () => {
  return [
    ..._.map(nav, depth1 => ({
      path: `/${depth1.route}`,
      redirect: `${depth1.isActiveNum ? `/${depth1.route}/${depth1.children[depth1.isActiveNum].route}` : `/${depth1.route}/${depth1.children[0].route}`}`
    })),
    ..._.flatten(
      _.map(nav, depth1 =>
        _.map(depth1.children, depth2 => ({
          path: `/${depth1.route}/${depth2.route}`,
          component: view(`/pages/${depth1.route}/${depth2.view || depth2.route}${depth2.langSplit ? `.${store.state.lang}` : ''}`),
          meta: { label: depth2.label, depth1: depth1, ...depth2.meta }
        }))
      )
    )
  ];
};

const router = () =>
  new Router({
    mode: 'history',
    scrollBehavior: (to, from, savedPosition) => {
      if (to.hash) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve({ selector: to.hash, offset: { y: 100 } });
          }, 300);
        });
      }
      if (savedPosition) {
        return new Promise(resolve => {
          setTimeout(() => {
            resolve(savedPosition);
          }, 100);
        });
      }
      return { x: 0, y: 0 };
    },
    routes: [
      {
        path: '/',
        component: view('/Main'),
        meta: { main: true }
      },
      ...subsFromNav()
    ]
  });

export default router;
